import ArtigoPlaceholder from "@/components/feature/ArtigoPlaceholder";
export default function ArtigoTamanhos() {
  return (
    <ArtigoPlaceholder
      title="Guia de Tamanhos para Roupas Chinesas: Nunca Mais Erre na Compra"
      desc="Tabela completa de conversão de tamanhos China x Brasil x Portugal. Aprenda a medir corretamente e interpretar as tabelas dos fornecedores no CSSBuy Spreadsheet."
      icon="ri-ruler-line"
      slug="artigo-cssbuy-tamanhos"
    />
  );
}